const trackerMatches = (tracker, id) => {
  if (tracker.regex) {
    const re = new RegExp(tracker.regex);
    return re.test(id);
  } else {
    return tracker.id === id;
  }
};
export { trackerMatches as default };
//# sourceMappingURL=trackerMatches.js.map
